import { render, staticRenderFns } from "./RegisteredByToken.vue?vue&type=template&id=79bd76fe&scoped=true"
import script from "./RegisteredByToken.vue?vue&type=script&lang=ts"
export * from "./RegisteredByToken.vue?vue&type=script&lang=ts"
import style0 from "./RegisteredByToken.vue?vue&type=style&index=0&id=79bd76fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@neverendingsupport+vue2@2.7.22-template-compiler_css-loader@6.8.1_w_d42ce3051c75faa7db91f2390d07a734/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79bd76fe",
  null
  
)

export default component.exports